import { render } from "./_404.vue?vue&type=template&id=2078b5d2"
const script = {}

import exportComponent from "/usr/src/citizenm/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__